export const state = {
  data: [],
  values: [{ values: { type: '0' } }],
  type: undefined,
  isLoad: false,
  queue: [[]],
  formIdx: null,
  step: 0,
  field: 0,
  formid: undefined
}
